import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';
import md5 from 'crypto-js/md5';

import fields from '../../lib/fields';
import { appConfirm } from '../../lib/dialogs';
import { beginDialogAction } from '../../lib/dialogAction';

const LIMIT = 24;

function conventionImg(img, props, size = '150x') {
    if (typeof img !== 'object') {
        return undefined;
    }
    const imgSrc = `${img.s3LargeLink}`;
    return imgSrc;
}

function participantExists(participants, key, value) {
    return participants.some(participant => participant[key] === value);
}

function memberExists(members, key, value) {
    return members.some(member => member[key] === value);
}

function generateArray(X) {
    const myNewShinyArray = [...Array(parseInt(X, 10) + 1).keys()];
    myNewShinyArray.shift();
    return myNewShinyArray;
}

@observer
class Convention extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            sections: fields.get('convention'),
        };
        this.mainContainer = null;
    }

    newConvention = e => {
        const { id, title } = e.target.closest('button').dataset;
        const { drawerLevel = 1 } = this.props;
		const { appState, timetrackersStore } = this.props.stores;
		const { drawerHeightLarge } = appState;
		appState.openDrawer('conventionWizard', {
			height: drawerHeightLarge,
            callback: () => {
                appState.toggleDrawer();
                this.loadAll(this.props, false);
            },
		}, drawerLevel + 2);
	}

    viewConvention = (e, props) => {
        const { view } = this.props;
        if (view) {
            return view(e);
        }
        const { id, title } = props ? props : e.target.closest('.box-line').dataset;
        return route(`/convention/${id}`);

        // const { appState } = this.props.stores;
        // const { drawerLevel = 1 } = this.props;
        // const { drawerHeightLarge } = appState;
        // appState.openDrawer('viewConvention', {
        //     id,
        //     height: drawerHeightLarge,
        //     // editFunction: this.editTimeConvention,
        //     callback: () => {
        //         appState.toggleDrawer();
        //         this.loadAll(this.props, false);
        //     },
        // }, drawerLevel + 1);
    }

    viewTags = obj => {
        if (obj.tags?.length === 0 && obj.loans?.length === 0 && !obj.ownedByOther && !obj.url && !obj.parents?.length > 0 && !obj.files?.length > 0) {
            return '';
        }
        const { userStore } = this.props.stores;
        const { user = {} } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const tagClass = darkmode ? 'dark' : 'light';

        return (<>
            <div class='w-100 overflow-hidden'>
                <div class='box-line-tags d-flex flex-nowrap'>
                    {obj.files?.length > 0 && <>
                        <span class={`badge text-bg-light me-1 mt-1`}>
                            <i class='fa-duotone fa-file' /> <span class='font-weight-lighter'> x {obj.files.length}</span>
                        </span>
                    </>}
                    {obj.tags?.length > 0 && obj.tags.map(tag => {
                        return (<>
                            <span
                                class={`badge text-bg-${tagClass} me-1 mt-1`}
                                onClick={this.toggleTagFilter}
                                data-tag={tag.name}
                            >#{tag.name}</span>
                        </>);
                    })}
                </div>
            </div>
        </>);
    }

    loadAll = async (props = this.props) => {
        const { id, currentUserOnly } = props;
        const { conventionStore, conventionResultStore, userStore } = this.props.stores;
        const { user = {} } = userStore;
        await conventionStore.load({
                query: {
                participant: user.id,
                hostname: conventionStore.currentHostname,
            },
            addData: ['tags', 'members'],
            limit: 1000,
            sort: '-startDate',
        });
        const conventionIds = conventionStore.conventions.map(e => e.id);
        const conventionsResultQuery = {
            convention: conventionIds,
        };
        if (currentUserOnly) {
            conventionsResultQuery.participant = user.id;
        }
        await conventionResultStore.load({
            query: {
                ...conventionsResultQuery,
            },
            limit: 5000,
        });
    }

    editParticipant = async e => {
        const { id, md5, stage, idx } = e.target.closest('i').dataset;
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { drawerHeightSmall } = appState;
// console.log({ id, md5, stage, idx });
        appState.openDrawer('editConventionParticipant', {
            id,
            md5,
            stage,
            idx,
            height: drawerHeightSmall,
            callback: () => {
                this.loadAll(this.props, false);
            },
        }, drawerLevel + 1);
    }

    filterParticipants = participant => {
        const { isConventionAdmin, showAll } = this.state;
        if (isConventionAdmin || showAll) {
            return true;
        }
        const { userStore } = this.props.stores;
        const { user } = userStore;
        return user.id === participant.id;
    }

    toggleShowAll = () => {
        this.setState({ showAll: !this.state.showAll });
    }

    toggleStats = () => {
        this.setState({ showStats: !this.state.showStats });
    }

    requestSigning = async () => {
        const { formSigningRequestStore, appState } = this.props.stores;
        const { offset = 0 } = this.state;
        const customer = appState.currentCustomer && appState.currentCustomer.id;
        const response = await formSigningRequestStore.createRequest({ formType: 'convention', offset, customer });
        if (response && response.status === 201) {
            this.setState({ signingRequested: true });
        }
    };

    deleteSigningRequest = async (id) => {
        const dialogAction = beginDialogAction(this, 'deleteSigningRequest');
        if (!dialogAction) return false;
        try {
            if (!((await appConfirm('Delete this signing request?')) && dialogAction.isCurrent())) {
                return;
            }
            const { formSigningRequestStore } = this.props.stores;
            await formSigningRequestStore.deleteRequest(id);
        } finally {
            dialogAction.finish();
        }
    };

    componentDidMount() {
        this.loadAll();
        const { conventionStore, formSigningRequestStore } = this.props.stores;
        conventionStore.deleteReloadTimer();
        formSigningRequestStore.load();
    }

    // componentWillReceiveProps(nextProps) {
    //     if (nextProps.page !== this.props.page || nextProps.artid !== this.props.artid) {
    //         this.loadAll(nextProps);
    //     }
    // }

    render() {
        const { showAll, showStats, offset = 0 } = this.state;
        const {
            classNames = '',
            title = 'Stevner / treninger',
            children,
            todayOnly,
        } = this.props;

        const { appState, userStore, conventionStore, conventionResultStore, formSigningRequestStore } = this.props.stores;
        const { mainView, subView, isDevelopment, path } = appState;
        const { user = {}, isAdmin, isTester, isVeterinary, language } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { conventions = [] } = conventionStore;
        const { conventionResults = [] } = conventionResultStore;

        const { formSigningRequests = [] } = formSigningRequestStore;
        const myRequests = formSigningRequests.filter(r => r.requester === user.id);

        const apiServer = util.getApiServer();
        const jwtToken = util.getJwtToken();

        const totalResults = conventions.length;
        const numIntervals = Math.ceil(totalResults / LIMIT);
        const intervals = Array.from({ length: numIntervals }, (_, index) => index * LIMIT);

        const yourStats = {
            type: {
            },
            class: {
            },
            topScore: {
            },
        };

        conventions?.forEach(convention => {
            convention.stages.forEach((stage, idx) => {
                const isFieldShooting = ['norgesfelt', 'felt'].includes(stage.type);
                const participants = convention[`participants${idx + 1}`];
                const you = participants?.find(participant => participant.id === user.id);
                if (you) {
                    yourStats.type[stage.type] = yourStats.type[stage.type] || 0;
                    yourStats.type[stage.type] += 1;
                    const classKey = `${you.class || 'n/a'}`;
                    if (classKey) {
                        const { totalScore: tot, totalIx: totIx } = conventionResultStore.totalScore({ participant: you, convention, stage, isFieldShooting });
                        yourStats.topScore[stage.type] = yourStats.topScore[stage.type] || 0;
                        yourStats.topScore[stage.type] = Math.max(yourStats.topScore[stage.type], tot);

                        const key = `${stage.type}-${classKey}`;
                        yourStats.topScore[key] = yourStats.topScore[key] || 0;
                        yourStats.topScore[key] = Math.max(yourStats.topScore[key], tot);

                        yourStats.class[classKey] = yourStats.class[classKey] || 0;
                        yourStats.class[classKey] += 1;
                    }
                }
            });
        });

        const allTypes = Object.keys(yourStats.type);

        return (<>
            {/* {todayOnly && conventions.length > 0 ? <>

                <div
					        	class='position-absolute rounded-pill w-75 d-flex flex-row justify-content-center align-items-center bg-orange text-white py-1'
        						style='
                                    z-index: 999999;
                                    bottom: 200px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    font-size: 0.9rem;
                                    line-height: 1.0rem;
                                    cursor: pointer;
                                    max-width: 300px;
                                '
    					    >
                                YO!
                            </div>

            </> : <></>} */}


            <button class={`btn btn-sm btn${showStats ? '' : '-outline'}-primary rounded-pill mt-2 mb-1`} onClick={this.toggleStats}>
                <i class='fa-duotone fa-chart-bar' /> <Text id='user.show-stats'>Show stats</Text>
            </button>
            {showStats && <>
                <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between mt-4'>
                    <Text id='convention.stats-shooting-programs'>Shooting programs</Text>
                </div>
                <div class={`d-flex flex-column justify-content-center mb-3 w-100 bg-light ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} rounded-lg p-2`}>
                    {/* <xmp>{JSON.stringify(allTypes, null, 2)}</xmp>
                    <xmp>{JSON.stringify(yourStats, null, 2)}</xmp> */}

                    <div class='table-responsive w-100'>
                        <table class='table table-sm table-striped'>
                            <thead>
                                <tr>
                                    <th class='text-muted w-50'><Text id='convention.stats-program'>Program</Text></th>
                                    <th class='text-muted text-center w-10'><Text id='convention.stats-count'>Count</Text></th>
                                    <th class='text-muted text-center w-10'><Text id='convention.stats-top-score'>Top Score</Text></th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(yourStats.type).map(type => {
                                    return (<>
                                        <tr>
                                            <td>
                                                {type}
                                            </td>
                                            <td class='text-center'>
                                                {yourStats.type[type]}
                                            </td>
                                            <td class='text-center'>
                                                {yourStats.topScore[type]}
                                            </td>
                                        </tr>
                                    </>);
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>


                <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between mb-1 mt-2'>
                    <Text id='convention.stats-shooting-weapons-types'>Weapon types</Text>
                </div>
                <div class={`d-flex flex-column justify-content-center mb-3 w-100 bg-light ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} rounded-lg p-2`}>
                    <div class='table-responsive w-100 mt-2'>
                        <table class='table table-sm table-striped'>
                            <thead>
                                <tr>
                                    <th class='text-muted w-50'><Text id='convention.stats-class'>Class</Text></th>
                                    <th class='text-muted text-center w-10'><Text id='convention.stats-count'>Count</Text></th>
                                    {allTypes.map(type => {
                                        return (<>
                                            <th class='text-muted text-center w-5'>{type}</th>
                                        </>);
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(yourStats.class).map(klass => {
                                    return (<>
                                        <tr>
                                            <td>
                                                {klass}
                                            </td>
                                            <td class='text-center'>
                                                {yourStats.class[klass]}
                                            </td>
                                            {allTypes.map(type => {
                                                const key = `${type}-${klass}`;
                                                return (<>
                                                    <td class='text-center'>
                                                        {yourStats.topScore[key]}
                                                    </td>
                                                </>);
                                            })}
                                        </tr>
                                    </>);
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>}


            <div class='d-flex flex-row flex-wrap justify-content-center align-items-center mb-2'>
                <a
                    class='btn btn-success text-white rounded-pill mt-3 mx-1'
                    href={`${apiServer}/api/conventions/download?jwtToken=${jwtToken}&offset=${offset}`}
                    target='_blank'
                >
                    <i class='fa-duotone fa-download' /> <Text id='user.download-police-form'>Download police form</Text>
                </a>
                <button
                    type='button'
                    class='btn btn-outline-primary rounded-pill mt-3 mx-1'
                    onClick={this.requestSigning}
                >
                    <i class='fa-duotone fa-signature' /> <Text id='user.request-signing'>Request signing</Text>
                </button>
                {this.state.signingRequested && (
                    <span class='ms-2 text-success'>
                        <i class='fa-duotone fa-check' /> <Text id='user.signing-requested'>Request sent</Text>
                        {' '}<a href='/signing-requests'><Text id='user.view-requests'>View requests</Text></a>
                    </span>
                )}
            </div>
            {conventions.length > LIMIT ? (
                <div class='d-flex justify-content-center mb-3'>
                    <select
                        class={`form-control rounded-lg w-auto`}
                        onInput={linkstate(this, 'offset')}
                    >
                        <option value=''>-- Velg start --</option>
                        {intervals.map(start => (
                            <option value={start} key={start}>
                                {start} - {Math.min(start + LIMIT, totalResults)}
                            </option>
                        ))}
                    </select>
                </div>
            ) : null}

            {myRequests.length > 0 && (
                <div class='mb-3'>
                    <h6 class='text-body-secondary'><Text id='signing.your-requests'>Your signing requests</Text></h6>
                    <div class='list-group'>
                        {myRequests.map(r => (
                            <div class='list-group-item d-flex justify-content-between align-items-center flex-wrap' key={r.id}>
                                <span>
                                    <span class='badge bg-secondary me-2'>{r.formType}</span>
                                    <span class='badge bg-info me-2'>{r.status}</span>
                                    <small class='text-body-secondary'>{util.formatDate(r.requestedDate)}</small>
                                    {r.status === 'rejected' && r.rejectedReason ? <small class='text-danger ms-2'>{r.rejectedReason}</small> : null}
                                </span>
                                <span class='d-flex gap-2 mt-1'>
                                    <a class='btn btn-sm btn-outline-secondary' target='_blank' rel='noreferrer' href={`${apiServer}/api/formsigningrequests/${r.id}/preview?jwtToken=${jwtToken}`}>
                                        <Text id='signing.preview'>Preview</Text>
                                    </a>
                                    {r.status === 'approved' ? (
                                        <a class='btn btn-sm btn-success' target='_blank' rel='noreferrer' href={`${apiServer}/api/formsigningrequests/${r.id}/download?jwtToken=${jwtToken}`}>
                                            <Text id='signing.download'>Download signed</Text>
                                        </a>
                                    ) : null}
                                    <button type='button' class='btn btn-sm btn-outline-danger' onClick={() => this.deleteSigningRequest(r.id)}>
                                        <i class='fa-duotone fa-trash' />
                                    </button>
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div class='w-100'>
                {conventions && conventions.length ? <>
                    {(() => {
                        // Group conventions by date
                        const groupedByDate = {};
                        conventions.forEach(convention => {
                            const dateKey = util.isoDate(convention.startDate, false, false, true);
                            if (!groupedByDate[dateKey]) {
                                groupedByDate[dateKey] = [];
                            }
                            groupedByDate[dateKey].push(convention);
                        });

                        return Object.keys(groupedByDate).map(dateKey => {
                            const dayConventions = groupedByDate[dateKey];
                            const firstConvention = dayConventions[0];
                            const currentYear = new Date().getFullYear();
                            const conventionYear = new Date(firstConvention.startDate).getFullYear();
                            const formattedDate = util.formatDate(firstConvention.startDate, {
                                weekday: 'long',
                                day: 'numeric',
                                month: 'short',
                                year: conventionYear !== currentYear ? 'numeric' : undefined,
                                locale: 'nb-NO'
                            });

                            return (<>
                                {/* Date header */}
                                <div
                                    class={`d-flex align-items-center mt-4 mb-2 pb-2`}
                                    style='border-bottom: 2px solid var(--bs-primary); opacity: 0.9;'
                                >
                                    <i class='fa-solid fa-calendar-day me-2 text-primary' />
                                    <span style='font-weight: 600; font-size: 1rem; text-transform: capitalize;'>
                                        {formattedDate}
                                    </span>
                                    <span class='ms-2 badge bg-secondary rounded-pill' style='font-size: 0.7rem;'>
                                        {dayConventions.reduce((count, c) => {
                                            return count + (c.stages?.filter((stage, idx) => {
                                                const participants = c[`participants${idx + 1}`];
                                                return showAll || (participants && participants.some(p => p.id === user.id));
                                            }).length || 0);
                                        }, 0)} <Text id='convention.stages'>stages</Text>
                                    </span>
                                </div>

                                {/* Conventions for this date */}
                                {dayConventions.map(convention => {
                                    // Filter stages where user is participant
                                    const visibleStages = convention.stages?.filter((stage, idx) => {
                                        const participants = convention[`participants${idx + 1}`];
                                        return showAll || (participants && participants.some(p => p.id === user.id));
                                    }) || [];

                                    if (visibleStages.length === 0 && !showAll) {
                                        return null;
                                    }

                                    return (<>
                                        <div class={`mb-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-light'}`} style='overflow: hidden;'>
                                            {/* Convention header */}
                                            <div
                                                class='d-flex align-items-center justify-content-between px-3 py-2'
                                                style={`background: ${darkmode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'}; border-bottom: 1px solid ${darkmode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'};`}
                                            >
                                                <div class='d-flex align-items-center'>
                                                    <span class='text-muted me-2' style='font-size: 0.85rem;'>
                                                        {util.formatDate(convention.startDate, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}
                                                    </span>
                                                    <span style='font-weight: 500;'>{convention.title}</span>
                                                    {!!convention.isCancelled && (
                                                        <span class='badge text-bg-danger ms-2' style='font-size: 0.7rem;'>
                                                            <i class='fa-solid fa-ban me-1' />Avlyst
                                                        </span>
                                                    )}
                                                    {(isAdmin || convention.user === user.id) && convention.totalViews > 0 && (
                                                        <span class='ms-2 text-muted' style='font-size: 0.7rem;'>
                                                            <i class='fa-solid fa-eye' /> {convention.totalViews}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Stages */}
                                            {visibleStages.length > 0 ? (
                                                visibleStages.map((stage, idx) => {
                                                    const originalIdx = convention.stages.indexOf(stage);
                                                    const isFieldShooting = ['norgesfelt', 'felt'].includes(stage.type);
                                                    const participants = convention[`participants${originalIdx + 1}`];

                                                    return (<>
                                                        <div class='px-3 py-2' style={idx > 0 ? `border-top: 1px solid ${darkmode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'};` : ''}>
                                                            {/* Stage info line */}
                                                            <div class='d-flex align-items-center justify-content-between mb-2'>
                                                                <div class='d-flex align-items-center flex-wrap gap-1'>
                                                                    <span class={`badge ${darkmode ? 'bg-dark' : 'bg-white border'} me-2`} style='font-size: 0.75rem; font-weight: 500; white-space: nowrap; flex-shrink: 0;'>
                                                                        {stage.name}
                                                                    </span>
                                                                    <span class='text-muted' style='font-size: 0.8rem;'>{stage.type}</span>
                                                                    {participants && participants.filter(this.filterParticipants).map((participant) => {
                                                                        const isYou = participant.id === user.id;
                                                                        return (<>
                                                                            <span class='ms-2 text-muted' style='font-size: 0.8rem;'>
                                                                                - {participant.class}
                                                                                {isYou && (
                                                                                    <i
                                                                                        class='fa-solid fa-edit ms-1'
                                                                                        style='cursor: pointer; opacity: 0.6;'
                                                                                        data-id={convention.id}
                                                                                        data-md5={participant.md5}
                                                                                        data-stage={stage.md5}
                                                                                        data-idx={originalIdx}
                                                                                        onClick={this.editParticipant}
                                                                                    />
                                                                                )}
                                                                            </span>
                                                                        </>);
                                                                    })}
                                                                </div>
                                                            </div>

                                                            {/* Scores table */}
                                                            <div class='table-responsive'>
                                                                <table class='table table-sm mb-0' style='font-size: 0.85rem;'>
                                                                    <thead>
                                                                        <tr>
                                                                            {isFieldShooting ? <>
                                                                                {conventionResultStore.generateArray(stage.stages || 10).map(stand => (
                                                                                    <th class='text-muted text-center px-1' style='font-weight: 400; font-size: 0.7rem;'>{stand}</th>
                                                                                ))}
                                                                                <th class='text-muted text-center px-1' style='font-weight: 400; font-size: 0.7rem;'>iX</th>
                                                                            </> : <>
                                                                                {conventionResultStore.getParticipantFields(stage).map((field) => (
                                                                                    <th class='text-muted text-center px-1' style='font-weight: 400; font-size: 0.7rem;'>{field}</th>
                                                                                ))}
                                                                            </>}
                                                                            <th class='text-muted text-end px-1' style='font-weight: 500; font-size: 0.75rem;'>Totalt</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {participants && participants.filter(this.filterParticipants).map((participant) => {
                                                                            const participantResults = conventionResults.filter(result =>
                                                                                result.participant === participant.id &&
                                                                                result.stage === stage.md5 &&
                                                                                convention.id === result.convention
                                                                            );
                                                                            let totalScore = 0;
                                                                            let totalIx = 0;

                                                                            if (isFieldShooting) {
                                                                                return (
                                                                                    <tr>
                                                                                        {conventionResultStore.generateArray(stage.stages || 10).map(stand => {
                                                                                            let standScore = 0;
                                                                                            const targetResult = participantResults.find(result => result.stand === stand);
                                                                                            standScore += targetResult?.scoreHits || 0;
                                                                                            standScore += targetResult?.scoreTargets || 0;
                                                                                            if (targetResult?.scorePenalty) {
                                                                                                standScore -= targetResult.scorePenalty;
                                                                                            }
                                                                                            totalScore += standScore;
                                                                                            totalIx += targetResult?.scoreInner || 0;
                                                                                            return (
                                                                                                <td class='text-center px-1'>{standScore || ''}</td>
                                                                                            );
                                                                                        })}
                                                                                        <td class='text-center px-1 text-muted'>{totalIx || ''}</td>
                                                                                        <td class='text-end px-1'>
                                                                                            <strong style='font-size: 1.1rem;'>{totalScore || 0}</strong>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            }

                                                                            return (
                                                                                <tr>
                                                                                    {conventionResultStore.getParticipantFields(stage).map((field, index) => {
                                                                                        const targetResult = participantResults.find(result => result.targetIndex === index);
                                                                                        if (targetResult) {
                                                                                            totalScore += targetResult.scoreTotal;
                                                                                        }
                                                                                        return (
                                                                                            <td class='text-center px-1'>{targetResult?.scoreTotal || ''}</td>
                                                                                        );
                                                                                    })}
                                                                                    <td class='text-end px-1'>
                                                                                        <strong style='font-size: 1.1rem;'>{totalScore || 0}</strong>
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </>);
                                                })
                                            ) : (
                                                <div class='px-3 py-2 text-muted' style='font-size: 0.85rem; font-style: italic;'>
                                                    <Text id='convention.no-stages'>No stages defined!</Text>
                                                </div>
                                            )}
                                        </div>
                                    </>);
                                })}
                            </>);
                        });
                    })()}
                </> : <></>}
            </div>
        </>);
    }
}

export default Convention;
